// extracted by mini-css-extract-plugin
module.exports = {"price":"_uu","inverted":"_uv","separator":"_uw","strikeout":"_ux","discount":"_uy","preliminaryValue":"_uz","gray":"_uA","locked":"_uB","finalPrice":"_uC"};